<template>
  <v-card>
    <v-card-title>
      <span> {{ currentComponentTitle }}</span>
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="cancel"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text :style="maxHeightStyle">
      <component
        :is="currentComponent"
        :id="id"
        :application="application"
        @close-dialog="close"
        @change-invalid="changeCardInvalid"
      ></component>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-on:click="cancel" color="blue darken-1" text> Отмена </v-btn>
      <v-btn
        v-on:click="save"
        :disabled="!isChanged || cardInvalid"
        color="blue darken-1"
        text
      >
        Сохранить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ExpressCard from "@/components/express/Card";
import ExpertCard from "@/components/expert/Card";

import { ACTIONS, GETTERS, MUTATIONS } from "@/store";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "TheCard",
  components: { ExpressCard, ExpertCard },
  props: {
    id: {
      type: Number,
      required: true,
    },
    fullscreen: {
      type: Boolean,
      required: false,
      default: false,
    },
    application: { type: String },
  },
  data: () => ({
    cardInvalid: false,
  }),
  computed: {
    ...mapGetters({
      dict4: GETTERS.DICTIONARY_4,
      isChanged: GETTERS.CARD_IS_CHANGED,
      isExpert: GETTERS.USER_IS_EXPERT,
    }),
    currentComponent() {
      return this.isExpert ? "ExpertCard" : "ExpressCard";
    },
    currentComponentTitle() {
      return this.isExpert
        ? "Единая, полная карта ИТЗ"
        : "Экспресс-карта регистрации ИТЗ";
    },
    maxHeightStyle() {
      if (this.fullscreen) return "";
      return "max-height: 700px;";
    },
  },
  methods: {
    ...mapActions({
      saveData: ACTIONS.SAVE_CARD_DATA,
    }),
    ...mapMutations({
      cancelChanges: MUTATIONS.CANCEL_CARD_DATA_CHANGES,
    }),
    save() {
      this.saveData(this.id);
      this.$emit("close-dialog");
    },
    cancel() {
      this.cancelChanges();
      this.$emit("close-dialog");
    },
    close() {
      this.$emit("close-dialog");
    },
    changeCardInvalid(value) {
      this.cardInvalid = value;
    },
  },
};
</script>
